// extracted by mini-css-extract-plugin
export default {"footer":"PageFooter_footer__U-s-T","footer-text":"PageFooter_footer-text__8LlbQ","logo":"PageFooter_logo__eYMIt"};